import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SlideOutWrapper } from './SlideOutWrapper';
import FeesCard from '../fees/FeesCard';
import { useGetDrawerWidth, UnsavedChangesConfirmationModal, useUnsavedChangesModal } from '@makemydeal/dr-dash-components';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { getReturnToOfferButton } from '@makemydeal/dr-shared-ui-utils';
import type { SlideOutComponentProps } from '../../types';

export const FeesSlideOut = ({ isOpen, onClose }: SlideOutComponentProps) => {
    const panelWidth = useGetDrawerWidth({
        extraLarge: 984,
        large: 984,
        tablet: 984,
        small: 690
    });

    const govFees = useSelector(offerSelectors.getItemizedGovernmentFees);
    const dealerFees = useSelector(offerSelectors.getItemizedDealerFees);
    const lenderFees = useSelector(offerReduxSelectors.getItemizedLenderFees);

    const feesData = useMemo(() => ({ govFees, dealerFees, lenderFees }), [govFees, dealerFees, lenderFees]);

    const {
        isDirtyRef: isFeesDirtyRef,
        showConfirmationModal,
        handleClose,
        handleCancelChanges,
        handleContinueEditing
    } = useUnsavedChangesModal({
        savedData: feesData,
        onClose
    });

    return (
        <>
            <SlideOutWrapper
                title={'Fees'}
                isOpen={isOpen}
                onClose={handleClose}
                panelWidth={panelWidth}
                testId="tab-slideout-fees"
                footer={getReturnToOfferButton(handleClose)}
            >
                <FeesCard isFeesDirtyRef={isFeesDirtyRef} isInsideSlideOut shouldTriggerValidation={showConfirmationModal} />
            </SlideOutWrapper>
            <UnsavedChangesConfirmationModal
                show={showConfirmationModal}
                onCancelChanges={handleCancelChanges}
                onContinueEditing={handleContinueEditing}
            />
        </>
    );
};
